import { t } from 'i18next';

export const fleetTabs = {
  account: {
    key: 'account',
    label: t('fleet.account'),
  },
  orders: {
    key: 'orders',
    label: t('orders.orders'),
  },
  contacts: {
    key: 'contacts',
    label: t('common.contact.contacts'),
  },
  vehicles: {
    key: 'vehicles',
    label: t('common.vehicle.vehicles'),
  },
  status: {
    key: 'status',
    label: t('common.status.status'),
  },
};
